'use strict';

var React = require('react');

var SvgVariantMajor = function SvgVariantMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-3.5v2.5a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h2.5v-3.5a1.5 1.5 0 0 1 1.5-1.5h12zm-6.5 13h6v-6l-6 6zm-9 4h10v-2.027l-6.495.022a1.5 1.5 0 0 1-1.505-1.5v-6.495h-2v10zm10-15h-6v6l6-6z"
  }));
};

exports.SvgVariantMajor = SvgVariantMajor;
